export default __webpack_public_path__ + "static/media/sunset.16640053.svg";